import API from "../api/axios.config";

class ProblemService {
  getAllProblemTypes() {
    return API.get("/problem/");
  }
  getProblem(id) {
    return API.get(`/problem/${id}`);
  }

  getProject(id) {
    return API.get(`/problem/project/${id}`);
  }

  getProblems(id) {
    return API.get(`/problem/list/${id}`);
  }
}

export default new ProblemService();